import { Routes } from '@angular/router';
import { EnterpriseViewComponent } from './enterprise-view/enterprise-view.component';
import { SeverityViewComponent } from './severity-view/severity-view.component'
import { PlantViewComponent } from './plant-view/plant-view.component';
import { TrendChartComponent } from './trend-chart/trend-chart.component';
import { SeverityTrendChartComponent } from './severity-trend-chart/severity-trend-chart.component';
import { ChartSideNavComponent } from './chart-side-nav/chart-side-nav.component';
import { SiteTrendChartComponent } from './site-trend-chart/site-trend-chart.component';
import { TrendSampleRateComponent } from './trend-sample-rate/trend-sample-rate.component';
import { GeaMesLoginComponent, GeaMesCognitoAuthGuard, GeaMesLogoutComponent, GeaMesAccessDeniedComponent } from '@gea-mes/cognito';
import { AnalysisHomeComponent } from './analysis/analysis-home/analysis-home.component';
import { AlarmDetailViewComponent } from './alarm-detail-view/alarm-detail-view.component';
import { ShopfloorTopThreeComponent } from './severity-view/shopfloor-top-three/shopfloor-top-three.component';

export const routes: Routes = [
  { path: 'login', component: GeaMesLoginComponent },
  { path: 'logout', component: GeaMesLogoutComponent },
  { path: 'accessdenied', component: GeaMesAccessDeniedComponent },
  
  {
    path: '', canActivate: [GeaMesCognitoAuthGuard],
  children: [
    { path: '', component: EnterpriseViewComponent }, 
    { path: 'apps', component: EnterpriseViewComponent },
    { path: 'plantView/:plant', component: PlantViewComponent },
    { path: 'plantView/:plant/:plantdisplay', component: PlantViewComponent },
    { path: 'details/:plant', component: SeverityViewComponent },
    { path: 'details/:plant/:plantdisplay/:linedisplay', component: SeverityViewComponent },
    { path: 'resultIDdetails/:plant/:resultid', component: AlarmDetailViewComponent},
    { path: 'charts', component: ChartSideNavComponent,
        children:[
          {path: "trendChart/:plant", component: TrendChartComponent},
          {path: "trendChart/:plant/:line", component: TrendChartComponent},
          {path: 'severityTrendChart/:plant', component: SeverityTrendChartComponent},
          {path: 'siteTrendChart/:plant', component: SiteTrendChartComponent},
          {path: 'sampleRate/:plant', component: TrendSampleRateComponent}
        ]
    },
    {path: 'analysis/:plant', component: AnalysisHomeComponent},
    {path: 'shopfloor/:plant/:line', component: ShopfloorTopThreeComponent} 
    ]
  },
  { path: '**', component: EnterpriseViewComponent }
];
